const subtitlesExportOptionsList = [
  // { type: 'srt', label: 'Srt', ext: 'srt' },
  { type: 'vtt', label: 'VTT', ext: 'vtt' },
  //{ type: 'vtt_speakers', label: 'VTT with speakers', ext: 'vtt' },
  // { type: 'vtt_speakers_paragraphs', label: 'VTT with speakers and paragraphs', ext: 'vtt' },
  // { type: 'itt', label: 'iTT', ext: 'itt' },
  // { type: 'ttml', label: 'TTML', ext: 'ttml' },
  // { type: 'premiereTTML', label: 'TTML for Adobe Premiere', ext: 'ttml' },
  // { type: 'csv', label: 'CSV', ext: 'csv' },
  // { type: 'pre-segment-txt', label: 'Pre segmented txt', ext: 'txt' },
  // { type: 'json', label: 'Json', ext: 'json' },
];

export default subtitlesExportOptionsList;
